// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { LhoHousePage, LhoUnitPage, LhoPropertyPage } from "./"

export default {
  path: "lho",
  name: "LHO explorer",
  childRoutes: [
    {
      exact: true,
      path: ":propertyRef.:houseRef.:unitRef",
      name: "unit page",
      component: LhoUnitPage,
    },
    { exact: true, path: ":propertyRef.:houseRef", name: "house page", component: LhoHousePage },
    { exact: true, path: ":propertyRef", name: "property page", component: LhoPropertyPage },
  ],
}



// WEBPACK FOOTER //
// ./src/features/lho-explorer/route.js